import { SecuritiesDropDown, UIDropDownDTO, IPortfolioRestrictions } from "@irb/irb-editors/irb-editors.model";

export class AltSecDropDownComponent {

    _altSecuritySymbol: UIDropDownDTO;

    _restrictionSecSymbol: UIDropDownDTO;

    _securitiesDropDown: SecuritiesDropDown;

    _pfRestriction: IPortfolioRestrictions;

    get altSecuritySymbol() {
        return this._altSecuritySymbol;
    }

    set altSecuritySymbol(altSec: UIDropDownDTO) {
        this._altSecuritySymbol = altSec;
    }

    get restrictionSecSymbol() {
        return this._restrictionSecSymbol;
    }

    set restrictionSecSymbol(secSymbol: UIDropDownDTO) {
        this._restrictionSecSymbol = secSymbol;
    }

    get securitiesDropDown() {
        return this._securitiesDropDown;
    }

    set securitiesDropDown(secs: SecuritiesDropDown) {
        this._securitiesDropDown = secs;
    }

    get pfRestriction() {
        return this._pfRestriction;
    }

    set pfRestriction(restriction: IPortfolioRestrictions) {
        this._pfRestriction = restriction;
    }

    public populateSecuritiesDropdown(params: any) {
        this.securitiesDropDown = params.data.securitiesDropDown;
        if (this.securitiesDropDown) {
            this.securitiesDropDown.items.forEach(secDropDown => {
                if (this.altSecuritySymbol) {
                    if (secDropDown.name == this.altSecuritySymbol.name && secDropDown.id == this.altSecuritySymbol.id) {
                        this.altSecuritySymbol = secDropDown;
                    }
                }
                if (this.restrictionSecSymbol) {
                    if (secDropDown.name == this.restrictionSecSymbol.name && secDropDown.id == this.restrictionSecSymbol.id) {
                        this.restrictionSecSymbol = secDropDown;
                    }
                }
            });
            delete params.data.securitiesDropDown;
        }
    }

    public populateAltSecurity(params: any) {
        if (params.data) {
            this.pfRestriction = params.data;
            if (this.pfRestriction.condition == 'Buy an alternate security') {
                if (this.pfRestriction.securitySymbol != null && this.pfRestriction.securityMasterId != null) {
                    this.restrictionSecSymbol = {name: this.pfRestriction.securitySymbol, id: this.pfRestriction.securityMasterId+"", versionId: null};
                }
                if (this.pfRestriction.altSecuritySymbol != null && this.pfRestriction.altSecurityId != null) {
                    this.altSecuritySymbol = {name: this.pfRestriction.altSecuritySymbol, id: this.pfRestriction.altSecurityId+"", versionId: null};
                }
            }
        }
    }

    public removeRestrictionSymbolFromDropDown() {
        if (this.restrictionSecSymbol && this.securitiesDropDown) {
            const index = this.securitiesDropDown.items.indexOf(this.restrictionSecSymbol, 0);
            if (index > -1) {
                this.securitiesDropDown.items.splice(index, 1);
            }
        }
    }

}